// Vendors
import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Components
import { formatEquipmentType } from '../../../../helpers';

const BulkMessage = ({
  applications,
  adminFilters: { status },
  setMainNotice
}) => {
  const [bulkMessage, setBulkMessage] = useState('');
  const [selectedProducers, setSelectedProducers] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [justSentMessage, setJustSentMessage] = useState(false);

  let allSelected =
    selectedProducers.length === Object.keys(filteredApplications).length &&
    selectedProducers.length > 0;

  const handleSelectProducers = (event) => {
    const { value } = event.target;
    let producerIds = [...selectedProducers];

    if (producerIds.includes(value)) {
      producerIds = producerIds.filter((id) => id !== value);
    } else {
      producerIds = [...producerIds, value];
    }

    setSelectedProducers(producerIds);
  };

  const handleSelectAllProducers = () => {
    let producerIds = [];

    !allSelected &&
      Object.values(filteredApplications).forEach((applications) => {
        let producerId = applications[0].producer.ID;
        producerIds = [...producerIds, producerId];
      });

    setSelectedProducers(producerIds);
  };

  // clear selection if status updates
  useEffect(() => {
    setSelectedProducers([]);
  }, [status]);

  const handleSendMessage = () => {
    if (!selectedProducers.length) return;

    setLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_fip_post_bulk_producer_message');
    formData.append('message', bulkMessage);
    formData.append('pids', selectedProducers);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        setLoading(false);

        if (success) {
          setJustSentMessage(true);
          setSelectedProducers([]);
          setBulkMessage('');
        }

        setMainNotice({
          type: success ? 'success' : 'error',
          message: data.message
        });
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });

        setLoading(false);
      });
  };

  useEffect(() => {
    let applicationsGroupedByProducer = {};

    // Sort json by producer's last name.
    const filteredApplications = applications.sort((a, b) => {
      const x = a.producer.last_name;
      const y = b.producer.last_name;
      return x < y ? -1 : x > y ? 1 : 0;
    });

    // Format data for checkboxes div.
    filteredApplications.map((application) => {
      const { last_name, first_name, user_email, ID } = application.producer;
      const propertyName =
        last_name && first_name
          ? `${last_name}, ${first_name} (${user_email})`
          : `${ID} ${user_email}`;

      if (applicationsGroupedByProducer.hasOwnProperty(propertyName)) {
        applicationsGroupedByProducer[propertyName].push(application);
      } else {
        applicationsGroupedByProducer[propertyName] = [application];
      }
    });

    setFilteredApplications({ ...applicationsGroupedByProducer });
  }, [applications]);

  return (
    <>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-top-0 u--margin-bottom-20" />
        <label
          className={`form__checkbox form__checkbox--sm u--margin-top-0 u--margin-bottom-10 ${
            selectedProducers.length === applications.length &&
            selectedProducers.length === 0
              ? 'form__checkbox--disabled'
              : ''
          }`}
        >
          <input
            type="checkbox"
            checked={allSelected}
            onChange={() => handleSelectAllProducers()}
          />{' '}
          {selectedProducers.length === applications.length &&
          selectedProducers.length !== 0
            ? 'Deselect'
            : 'Select'}{' '}
          <em className="u--margin-left-5 u--margin-right-5">all</em> {status}{' '}
          applications.
        </label>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--padding-top-0">
        <div className="nested-checkboxes-wrapper">
          {Object.keys(filteredApplications).length === 0
            ? `No ${status} applications.`
            : Object.entries(filteredApplications).map(
                ([producer, applications], index) => (
                  <ul key={index}>
                    <li>
                      <label className="form__checkbox form__checkbox--sm u--margin-top-0">
                        <input
                          type="checkbox"
                          onClick={(event) => handleSelectProducers(event)}
                          value={applications[0].producer.ID}
                          checked={selectedProducers.includes(
                            applications[0].producer.ID
                          )}
                        />
                        {producer}
                      </label>
                      <ul>
                        {applications.map(({ equipmentType, serialNumber }) => (
                          <small
                            style={{ display: 'block' }}
                            key={serialNumber}
                          >{`${formatEquipmentType(
                            equipmentType
                          )} - ${serialNumber}`}</small>
                        ))}
                      </ul>
                    </li>
                  </ul>
                )
              )}
        </div>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--padding-top-0">
        <div className="form__field u--margin-bottom-20">
          <textarea
            type="textarea"
            className="form__textarea form__textarea--sm"
            style={{ height: '200px' }}
            placeholder={
              selectedProducers.length === 0
                ? `(Select ${status} Producers to send a message to.)`
                : `(Send producer message to${
                    selectedProducers.length >= 1
                      ? ` ${selectedProducers.length}`
                      : ''
                  } ${status} ${
                    selectedProducers.length === 1 ? 'producer' : 'producers'
                  }.)`
            }
            value={bulkMessage}
            onChange={(event) => {
              if (justSentMessage) setJustSentMessage(false);
              setBulkMessage(event.target.value);
            }}
            disabled={loading}
          />
        </div>
        {allSelected && selectedProducers.length !== 0 && (
          <span className="u--display-block u--color-red u--margin-bottom-20">
            You will be sending a message to{' '}
            <strong>all {selectedProducers.length}</strong> Producers with
            applications in {status} status.
          </span>
        )}
        <button
          className={`btn btn--xs btn--green ${
            loading === true ? 'btn--loading' : ''
          }`}
          type="button"
          onClick={() => handleSendMessage()}
          disabled={
            selectedProducers.length === 0 ||
            loading === true ||
            justSentMessage == true
          }
        >
          <span className="btn__content">
            <span className="btn__text">Send Message to Producer</span>
          </span>
        </button>
      </div>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-0" />
      </div>
    </>
  );
};

export default BulkMessage;
